// extracted by mini-css-extract-plugin
export default {"goBackBtn":"PreviousButton_goBackBtn__eIHbL"};